import React from 'react'
import { useCommonServices } from '@lib/hooks'
import { NinetailedProvider } from '@ninetailed/experience.js-next'
import { ninetailedConfig } from './config'
import { NinetailedEnabledContext } from './shared'

export interface NinetailedDefaultProviderProps {
  children: React.ReactNode
}

export const NinetailedDefaultProvider: React.FC<NinetailedDefaultProviderProps> = ({ children }) => {
  const { ninetailedPersonalizationService } = useCommonServices()
  const isNinetailedEnabled = ninetailedPersonalizationService.isNinetailedEnabled()

  return (
    <NinetailedEnabledContext.Provider value={isNinetailedEnabled}>
      {isNinetailedEnabled ? (
        <NinetailedProvider
          clientId={ninetailedConfig.clientId}
          environment={ninetailedConfig.environment}
          plugins={ninetailedPersonalizationService.getPlugins()}
        >
          {children}
        </NinetailedProvider>
      ) : (
        children
      )}
    </NinetailedEnabledContext.Provider>
  )
}
